module.exports = __webpack_public_path__ + "static/media/intro_5.2fded71c.png";